import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 30 30" {...props}>
      <path d="M15.9102 0.158752C7.625 0.158752 0.910156 6.8736 0.910156 15.1588C0.910156 23.4439 7.625 30.1588 15.9102 30.1588C24.1953 30.1588 30.9102 23.4439 30.9102 15.1588C30.9102 6.8736 24.1953 0.158752 15.9102 0.158752ZM21.9102 16.6588H17.4102V21.1588C17.4102 21.9849 16.7363 22.6588 15.9102 22.6588C15.084 22.6588 14.4102 21.9849 14.4102 21.1588V16.6588H9.91016C9.08398 16.6588 8.41016 15.9849 8.41016 15.1588C8.41016 14.3326 9.08398 13.6588 9.91016 13.6588H14.4102V9.15875C14.4102 8.33258 15.084 7.65875 15.9102 7.65875C16.7363 7.65875 17.4102 8.33258 17.4102 9.15875V13.6588H21.9102C22.7363 13.6588 23.4102 14.3326 23.4102 15.1588C23.4102 15.9849 22.7363 16.6588 21.9102 16.6588Z" />
    </Svg>
  );
};

export default Icon;
